import React, { useState } from 'react';
import './index.scss';
import { getRecurrentReportTypes, WAITER_TYPES } from '../../../utils/enums';
import Waiter from '../Waiter/Waiter';
import { ModalPopup } from '../ModalPopup/ModalPopup';
import { useTranslation } from 'react-i18next';
import Dropdown from '../Dropdown';
import { sendDepotAutomatedReport } from '../../../api/reportsHistory-request';
import { getHistoryLocationParams } from '../../../utils/routesHelper';

const ResendRecurentReport = () => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [selectedValue, setSelectedValue] = useState();
    const params = getHistoryLocationParams(window.location.search);

    const handleOnSend = () => {
        if (!selectedValue || !params.id) return;

        sendDepotAutomatedReport(params.id, selectedValue.key).then(data => {
            setShowModal(false);
        });
    }

    return (
        <div className='resendRecurentReport'>
            <Waiter
                type={WAITER_TYPES.button}
                spanText={'Resend'}
                stopPropagation={true}
                useClass={'btn confirm'}
                handleOnClick={() => setShowModal(true)}
            />
            <ModalPopup containerModalClass={'resendRecurentReportPopup'} isOpen={showModal} content={(
                <div>
                    <div>
                        <Dropdown
                            canPrint={true}
                            isCanBeEmpty={true}
                            values={getRecurrentReportTypes()}
                            placeholder={t('settings.orderingmenu.RECURENT_REPORT_TYPE')}
                            labelField='value'
                            valueField='key'
                            searchBy='value'
                            value={selectedValue?.value}
                            onSelect={val => setSelectedValue(val)}
                        />
                    </div>
                    <div className='controls'>
                        <Waiter
                            type={WAITER_TYPES.button}
                            useClass={'btn confirm'}
                            stopPropagation={true}
                            spanText={t('basic.SAVE_BUTTON')}
                            handleOnClick={handleOnSend}
                            disabled={!selectedValue}
                        />
                        <button className={'btn denied'} onClick={() => setShowModal(false)}>
                            {t('basic.CANCEL_BUTTON')}
                        </button>
                    </div>
                </div>
            )} />
        </div>
    )
}

export default ResendRecurentReport;